<section
  class="w-full max-w-sm border-t border-gray-200 pt-4 text-center"
  aria-labelledby="cdai-download-heading"
>
  <h3
    id="cdai-download-heading"
    class="text-lg font-semibold text-gray-900"
  >
    Get the Career Driver app
  </h3>
  <p class="mx-auto mt-1 max-w-xs text-sm text-gray-500">
    Find better driving jobs faster — download free on iOS or Android.
  </p>

  <div class="mt-6 flex flex-wrap items-center justify-center gap-3">
    <a
      [href]="iosStoreUrl"
      target="_blank"
      rel="noopener noreferrer"
      [class]="iosButtonClass()"
      title="Download on the App Store"
    >
      <img
        [src]="iosStoreButtonSrc"
        alt="Download on the App Store"
        [class]="iosImageClass()"
        width="135"
        height="40"
      />
    </a>

    <a
      [href]="googlePlayUrl"
      target="_blank"
      rel="noopener noreferrer"
      [class]="androidButtonClass()"
      title="Get it on Google Play"
    >
      <img
        [src]="googlePlayButtonSrc"
        alt="Get it on Google Play"
        [class]="androidImageClass()"
        width="180"
        height="53"
      />
    </a>
  </div>

  <div class="mx-auto mt-6 w-[min(100%,220px)]">
    <div
      class="overflow-hidden rounded-[1.75rem] bg-gray-900 shadow-[0_20px_40px_-12px_rgba(15,23,42,0.35)] ring-1 ring-black/10"
    >
      <img
        [src]="screenshotSrc"
        alt="Career Driver app screenshot"
        class="block h-auto w-full"
        width="1260"
        height="2736"
        loading="lazy"
      />
    </div>
  </div>
</section>
